import { useEffect, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store';
import { useParams } from 'react-router-dom';
import { setNoticeFlowType } from '../../features/upload/uploadSlice';
import BkNoticeForm from './BkNoticeForm';
import { getActiveBanner } from 'src/features/user/utils';
import { getPaymentMethods } from 'src/features/company/utils';
import { PaymentMethodsStatus } from 'src/utils/enums/payment-method-status.enum';
import { OrganizationType } from 'src/utils/enums/organization-type.enum';

const NoticeFormWrapper = () => {
  const noticeType = useSelector((state: RootState) => state.upload.noticeType);
  const bannerStatus = useSelector((state: RootState) => state.user.bannerStatus);
  const paymentMethodsStatus = useSelector((state: RootState) => state.company.paymentMethodsStatus);
  const organizationType = useSelector((state: RootState) => state.user.currentUser.organization.type);

  const dispatch = useDispatch<AppDispatch>();

  const { type } = useParams();
  useLayoutEffect(() => {
    if (type) {
      dispatch(setNoticeFlowType(type));
    }
  }, []);

  useEffect(() => {
    if (bannerStatus === undefined) {
      dispatch(getActiveBanner());
    }
  }, []);

  useEffect(() => {
    if (
      paymentMethodsStatus === PaymentMethodsStatus.UNKNOWN &&
      organizationType &&
      organizationType !== OrganizationType.CHAPTER_13_TRUSTEE
    ) {
      dispatch(getPaymentMethods());
    }
  }, [organizationType]);

  return noticeType && <BkNoticeForm />;
};

export default NoticeFormWrapper;
